import { Injectable } from '@angular/core';
import {HttpInterceptor,HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse,HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {LogserviceService} from '../logservice/logservice.service';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Cache-Control': 'private, max-age=1200'
  })
};

@Injectable({
  providedIn: 'root'
})
export class AgentscriptService {
  // intercept(
  //   request: HttpRequest<any>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<any>> {

  //   if(request.url.includes("localhost"))
  //       {
  //           console.log('intercepting');
  //           request = request.clone({
  //               setHeaders: {
  //                 Authorization: localStorage.getItem('msal.idtoken')
  //               }
  //             });
  //           return next.handle(request);
  //       }

  // }
  constructor(private httpClient:HttpClient ,private logService:LogserviceService) { }
  httpHeaders = new HttpHeaders();

  backendUrl = environment.apiURL;



  getAllScripts(payload:any):Observable<any>
  {
    //return this.httpClient.po
    this.logService.logMessage('message','debug');
   // console.log(  this.httpClient.get('http://localhost:8080/sample/payload',httpOptions));
    return this.httpClient.post(this.backendUrl,payload,httpOptions).pipe(retry(2), catchError(this.handleError));

  }
  saveanswer(payload:any):Observable<any>
  {
    //return this.httpClient.po
   // console.log(  this.httpClient.get('http://localhost:8080/sample/payload',httpOptions));
    return this.httpClient.post(this.backendUrl + 'saveAnswer',payload, {
      headers: this.httpHeaders
    }).pipe(retry(2), catchError(this.handleError));


  }
  getScriptDetail(id :number){
    return this.httpClient.get(this.backendUrl + 'agentscripts/id/' + id, {
      headers: this.httpHeaders
    }).pipe(retry(2), catchError(this.handleError));
  }

  getobjectpermission(id :number){

    return this.httpClient.get(this.backendUrl + 'getRoleObjectCreatePermissions/' + id, {
      headers: this.httpHeaders
    }).pipe(retry(2), catchError(this.handleError));
  }

getnewanswer(id :number)
{
  return this.httpClient.get(this.backendUrl + 'getAnswer/' + id, {
    headers: this.httpHeaders
  }).pipe(retry(2), catchError(this.handleError));
}
  getpageforobject(id :number,objname:string){
    return this.httpClient.get(this.backendUrl + 'getpageforObject/' + id+'/objectName/'+objname, {
      headers: this.httpHeaders
    }).pipe(retry(2), catchError(this.handleError));
  }
  getPageByObject(objname:string){
    //console.log(objname);
    return this.httpClient.get(this.backendUrl + 'getPageByObject/'+objname, httpOptions).pipe(retry(2), catchError(this.handleError));
  }
  getPageById(id:number){
    //console.log(objname);
    return this.httpClient.get(this.backendUrl + 'cache/getPage/'+id, httpOptions).pipe(retry(2), catchError(this.handleError));
  }
  getReport(id:any){
    return this.httpClient.post(this.backendUrl+'gquery', {"entityName": "sreportview","id":id}, httpOptions);
}
  callAgentScriptPageData(pageId:any):Observable<any> {
    //this.logService.logMessage('Trigger agent script page data','debug');
    var payload = {"queryName": "AgentScriptFields.findByParentId","id":pageId};
    //return this.httpClient.post(this.backendUrl+'getNamedQuery',payload, httpOptions);
    return this.httpClient.post(this.backendUrl+'getNamedQuery',payload, httpOptions);
}
getAllScriptPagesData(scriptId:number) {
  console.log(scriptId);
  return this.httpClient.get(this.backendUrl + 'ASParentId/' + scriptId, {
      headers: this.httpHeaders
  }).pipe(retry(2), catchError(this.handleError));

  // .map(res=>{
  //     return this.getScriptPageFields(res);
  // });

}
getReportdata(payload){
  return this.httpClient.post(this.backendUrl+'analytics/run', payload, httpOptions);
}
getScriptRules(pageId: number):Observable<any> {
  return this.httpClient.post(this.backendUrl+'getNamedQuery', {"queryName": "AgentScriptScriptRules.findByParentId", "id": pageId}, httpOptions);
}
  private handleError(errorObj: HttpErrorResponse | any) {
    const _self = this;
    let errorMessage: string;
    let body: any;
    if (errorObj instanceof HttpErrorResponse) {
      if (errorObj.ok === false && errorObj.status === 0) {
        errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime.';
      } else {
        body = errorObj.error || '';
        errorMessage = body.message ? body.message : body.error.message;
      }
    }
    return throwError(errorMessage);
  }
  getMenus(id:any){
    //var payload = {"entityName": name};
    //return this.httpClient.post(this.backendUrl+ 'gquery',payload, httpOptions);
    return this.httpClient.get(this.backendUrl + 'getPickListValuesByID/' + id, {
        headers: this.httpHeaders
    }).pipe(retry(2), catchError(this.handleError));
}
}
